import { render, staticRenderFns } from "./PaymentMedthod.vue?vue&type=template&id=efbd9dfe"
import script from "./PaymentMedthod.vue?vue&type=script&lang=js"
export * from "./PaymentMedthod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports